import { useEffect, useState } from 'react'
import { loadSharedSpaces, type SharedSpace } from '@core/expenses'
import { SpendingCard } from './SpendingCard'

/**
 * Every space that has been opened to the family, on whatever screen asks.
 *
 * Renders nothing at all when no space is shared, which is the default — a
 * family where nobody has opened anything sees exactly the app they had
 * before. Rule 23, at the level of a whole feature.
 */
export function SharedSpaces({
  refreshKey,
  canEdit = false,
  userId,
}: {
  refreshKey?: number
  /** Whose upload a later-added receipt is. Only used when canEdit. */
  userId?: string
  /**
   * Only the administrator may correct or remove an expense. The database says
   * so too (0033) — this flag decides whether the option is offered, not
   * whether it is allowed, and a member's session could not do it either way.
   */
  canEdit?: boolean
}) {
  const [spaces, setSpaces] = useState<SharedSpace[]>([])

  useEffect(() => {
    loadSharedSpaces()
      .then(setSpaces)
      .catch(() => setSpaces([]))
  }, [refreshKey])

  if (spaces.length === 0) return null

  return (
    <>
      {spaces.map((space) => (
        <SpendingCard
          key={space.id}
          space={space}
          refreshKey={refreshKey}
          canEdit={canEdit}
          userId={userId}
        />
      ))}
    </>
  )
}
